import React from "react";
import CheckIcon from "@material-ui/icons/Check";
import moment from "moment";
import { cx } from "../utils";

const VARIANT_CONFIG = {
  published: {
    statusLabel: "Published",
    byLabel: "Published by",
  },
  resolved: {
    statusLabel: "Resolved",
    byLabel: "Resolved by",
  },
  acknowledged: {
    statusLabel: "Acknowledged",
    byLabel: "Acknowledged by",
  },
};

/**
 * CcPublishedCard — context-panel card for publish / resolve / acknowledge metadata.
 * Expects `by` (display name) and `at` (ISO or parseable date).
 */
const CcPublishedCard = ({
  variant = "published",
  by,
  at,
  className,
  ...props
}) => {
  const config = VARIANT_CONFIG[variant] || VARIANT_CONFIG.published;
  const formattedDate = at ? moment(at).format("D MMM YYYY, h:mm A") : "";
  const hasData = by || at;

  if (!hasData) return null;

  return (
    <article
      className={cx(
        "cc-published-card",
        `cc-published-card--${variant}`,
        className,
      )}
      {...props}
    >
      <header className="cc-published-card__status">
        <CheckIcon className="cc-published-card__check" aria-hidden />
        <span className="cc-published-card__status-label">
          {config.statusLabel}
        </span>
      </header>

      <div className="cc-published-card__meta">
        <span className="cc-published-card__avatar" aria-hidden />
        <div className="cc-published-card__details">
          <p className="cc-published-card__by-line">
            {by ? (
              <>
                {config.byLabel} <strong>{by}</strong> at
              </>
            ) : (
              config.byLabel
            )}
          </p>
          {formattedDate ? (
            <time className="cc-published-card__timestamp" dateTime={at}>
              {formattedDate}
            </time>
          ) : null}
        </div>
      </div>
    </article>
  );
};

export default CcPublishedCard;
